<template>
  <div>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="单据号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input placeholder="请输入单据号" v-model="queryParam.billNo"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="维修类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select placeholder="请选择维修类型" allow-clear v-model="queryParam.repairType">
                  <a-select-option value="费用化">费用化</a-select-option>
                  <a-select-option value="资本化">资本化</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select placeholder="请选择状态" allow-clear v-model="queryParam.status">
                  <a-select-option value="0">未审核</a-select-option>
                  <a-select-option value="1">已审核</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-range-picker style="width:100%" format="YYYY-MM-DD" v-model="queryParam.dateRange" @change="onDateChange" />
              </a-form-item>
            </a-col>
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-col :md="6" :sm="24">
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
              </a-col>
            </span>
          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮区域 -->
      <div class="table-operator" style="margin-top: 5px">
        <a-button type="primary" icon="plus" v-if="btnEnableList.indexOf('1') > -1" @click="openAdd">新增</a-button>
        <a-button style="margin-left: 8px" icon="sync" @click="loadData">刷新</a-button>
        <a-button style="margin-left: 8px" icon="download" v-if="btnEnableList.indexOf('3') > -1" @click="exportExcel">导出</a-button>
      </div>
      <a-table bordered size="middle" rowKey="id" :columns="columns" :dataSource="tableData"
        :loading="loading" :pagination="false" :scroll="tableScroll">
        <span slot="billTime" slot-scope="text">{{ text ? text.substring(0, 10) : '' }}</span>
        <span slot="status" slot-scope="text">
          <a-tag :color="text === '1' ? 'green' : 'orange'">{{ text === '1' ? '已审核' : '未审核' }}</a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handlePrint(record)">打印</a>
          <a-divider type="vertical" />
          <template v-if="record.status === '0'">
            <a @click="openEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a v-if="canAudit(billPrefix(record.billNo))" @click="handleAudit(record)">审核</a>
            <a-divider v-if="canAudit(billPrefix(record.billNo))" type="vertical" />
            <a v-if="canSubmitFlow(billPrefix(record.billNo))" @click="handleSubmitFlow(record)">提交审批</a>
            <a-divider v-if="canSubmitFlow(billPrefix(record.billNo))" type="vertical" />
            <a-popconfirm title="作废并删除该单据?" @confirm="() => handleDelete(record)">
              <a style="color: red;">作废</a>
            </a-popconfirm>
          </template>
          <template v-else>
            <a @click="openDetail(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="handleUnaudit(record)">反审核</a>
          </template>
        </span>
      </a-table>
      <a-pagination style="margin-top: 12px; text-align: right;" show-size-changer show-quick-jumper
        :current="ipagination.current" :page-size="ipagination.pageSize"
        :page-size-options="ipagination.pageSizeOptions" :total="ipagination.total"
        @change="handleTableChange" @showSizeChange="handleTableChange" />
    </a-card>

    <a-modal :title="form.id ? '编辑维修单' : '新增维修单'" :width="560" :visible="visible"
      :maskClosable="false" @cancel="visible = false">
      <a-form layout="vertical">
        <a-form-item label="资产（必选）">
          <a-select v-model="form.assetId" placeholder="选择资产" show-search option-filter-prop="children"
            style="width: 100%" :disabled="!!form.id">
            <a-select-option v-for="a in assetOptions" :key="a.id" :value="a.id">
              {{ a.assetCode }} {{ a.assetName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="维修类型（必选）">
          <a-select v-model="form.repairType" placeholder="选择维修类型" style="width: 100%">
            <a-select-option value="费用化">费用化（计入当期费用）</a-select-option>
            <a-select-option value="资本化">资本化（增加资产原值）</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="维修金额（必填）">
          <a-input-number v-model="form.amount" style="width: 100%" :min="0" :precision="2" />
        </a-form-item>
        <a-form-item label="维修内容">
          <a-textarea v-model="form.repairContent" :rows="3" />
        </a-form-item>
        <a-form-item label="贷方科目编码（缺省按凭证规则映射）">
          <a-input v-model="form.creditCode" placeholder="如 1002（留空走映射）" />
        </a-form-item>
        <a-form-item label="单据日期（必填）">
          <a-date-picker v-model="form.billTime" style="width: 100%" format="YYYY-MM-DD" />
        </a-form-item>
        <a-form-item label="备注"><a-input v-model="form.remark" /></a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="visible = false">取消</a-button>
        <a-button v-if="!multiOn(modalPrefix())" :loading="saving" @click="handleSave">保存</a-button>
        <a-button v-if="!multiOn(modalPrefix()) || !flowOn(modalPrefix())" :loading="saving" @click="handleSaveAndCheck">保存并审核</a-button>
        <a-button v-if="multiOn(modalPrefix()) && flowOn(modalPrefix())" :loading="saving" @click="handleSaveAndFlow">保存并提交流程</a-button>
      </template>
    </a-modal>

    <a-modal title="维修单详情" :width="560" :visible="detailVisible" :footer="null" @cancel="detailVisible = false">
      <a-descriptions bordered size="small" :column="1">
        <a-descriptions-item label="单据号">{{ detail.billNo }}</a-descriptions-item>
        <a-descriptions-item label="资产">{{ detail.assetCode }} {{ detail.assetName }}</a-descriptions-item>
        <a-descriptions-item label="维修类型">{{ detail.repairType }}</a-descriptions-item>
        <a-descriptions-item label="维修金额">{{ detail.amount }}</a-descriptions-item>
        <a-descriptions-item label="维修内容">{{ detail.repairContent }}</a-descriptions-item>
        <a-descriptions-item label="单据日期">{{ detail.billTime }}</a-descriptions-item>
        <a-descriptions-item label="备注">{{ detail.remark }}</a-descriptions-item>
      </a-descriptions>
    </a-modal>
    <asset-bill-print ref="assetPrint" />
  </div>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import ApprovalButtonMixin from './mixins/ApprovalButtonMixin'
import { repairList, repairGet, repairSave, repairDelete, repairAudit, repairUnaudit, assetList } from './api/fixedAsset'
import AssetBillPrint from './AssetBillPrint.vue'

export default {
  name: 'AssetRepairList',
  mixins: [JeecgListMixin, ApprovalButtonMixin],
  components: { AssetBillPrint },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18, offset: 1 },
      urlPath: '/plugin/fixed-asset/repair',
      prefixNo: 'ZCWX',
      loading: false,
      saving: false,
      visible: false,
      detailVisible: false,
      detail: {},
      form: {},
      tableData: [],
      assetOptions: [],
      tableScroll: { x: 'max-content', y: 400 },
      queryParam: {},
      ipagination: { current: 1, pageSize: 10, pageSizeOptions: ['10', '20', '50'], total: 0 },
      columns: [
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 220 },
        { title: '单据号', dataIndex: 'billNo', width: 160 },
        { title: '单据日期', dataIndex: 'billTime', width: 110, scopedSlots: { customRender: 'billTime' } },
        { title: '资产编码', dataIndex: 'assetCode', width: 130 },
        { title: '资产名称', dataIndex: 'assetName', width: 160 },
        { title: '维修类型', dataIndex: 'repairType', width: 90 },
        { title: '维修金额', dataIndex: 'amount', width: 110 },
        { title: '维修内容', dataIndex: 'repairContent', width: 200 },
        { title: '状态', dataIndex: 'status', width: 90, scopedSlots: { customRender: 'status' } }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => { this.tableScroll.y = Math.max(300, window.innerHeight - 360) })
  },
  created() {
    this.loadData()
    this.loadAssets()
    this.loadApprovalState()
  },
  methods: {
    loadData() {
      this.loading = true
      const params = {
        page: this.ipagination.current, pageSize: this.ipagination.pageSize,
        billNo: this.queryParam.billNo || null, repairType: this.queryParam.repairType || null,
        status: this.queryParam.status || null,
        beginTime: this.queryParam.beginTime || null, endTime: this.queryParam.endTime || null
      }
      repairList(params).then((res) => {
        this.loading = false
        if (res && res.success) {
          this.tableData = (res.data && res.data.records) || []
          this.ipagination.total = res.data.total || 0
        } else {
          this.$message.error((res && res.message) || '查询失败')
        }
      }).catch(() => { this.loading = false })
    },
    loadAssets() {
      assetList({ page: 1, pageSize: 500 }).then((res) => {
        if (res && res.success) this.assetOptions = (res.data && res.data.records) || []
      })
    },
    onDateChange(dateString) {
      if (dateString && dateString.length === 2) {
        this.queryParam.beginTime = dateString[0]
        this.queryParam.endTime = dateString[1]
      } else {
        this.queryParam.beginTime = ''
        this.queryParam.endTime = ''
      }
    },
    searchQuery() { this.ipagination.current = 1; this.loadData() },
    searchReset() {
      this.queryParam = {}
      this.ipagination.current = 1
      this.loadData()
    },
    handleTableChange(page, pageSize) {
      this.ipagination.current = page
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    openAdd() {
      this.form = {}
      this.visible = true
    },
    openEdit(r) {
      this.form = {
        id: r.id, assetId: r.assetId, repairType: r.repairType,
        amount: r.amount == null ? undefined : Number(r.amount),
        repairContent: r.repairContent, creditCode: r.creditCode,
        billTime: r.billTime, remark: r.remark
      }
      this.visible = true
    },
    openDetail(r) {
      repairGet(r.id).then((res) => {
        if (res && res.success) { this.detail = res.data || {}; this.detailVisible = true }
      })
    },
    /** 打印维修单（billTypeCode ZCWX） */
    handlePrint(r) {
      repairGet(r.id).then((res) => {
        if (res && res.success) {
          this.$refs.assetPrint.show(r.billNo, '资产维修单', res.data || {}, [])
        }
      })
    },
    /** 校验并保存，成功 resolve {id, billNo}，校验失败返回 null */
    saveBill() {
      if (!this.form.assetId) { this.$message.warning('请选择资产'); return null }
      if (!this.form.repairType) { this.$message.warning('请选择维修类型'); return null }
      if (this.form.amount == null) { this.$message.warning('请填写维修金额'); return null }
      if (!this.form.billTime) { this.$message.warning('请选择单据日期'); return null }
      const p = { ...this.form, billTime: this.form.billTime.length > 10 ? this.form.billTime.substring(0, 10) : this.form.billTime }
      this.saving = true
      return repairSave(p).then((res) => {
        if (!(res && res.success)) {
          this.$message.error((res && res.message) || '保存失败')
          return Promise.reject(new Error('保存失败'))
        }
        const id = res.data
        return repairGet(id).then((g) => {
          return { id: id, billNo: (g && g.data && g.data.billNo) || '' }
        }).catch(() => { return { id: id, billNo: '' } })
      }, () => {
        this.$message.error('保存失败')
        return Promise.reject(new Error('保存失败'))
      }).then((r) => { this.saving = false; return r }, (e) => { this.saving = false; return Promise.reject(e) })
    },
    handleSave() {
      const task = this.saveBill()
      if (!task) return
      task.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.loadData()
      }).catch(() => {})
    },
    /** 保存并审核 */
    handleSaveAndCheck() {
      const task = this.saveBill()
      if (!task) return
      this.saving = true
      task.then((r) => repairAudit(r.id)).then((res) => {
        this.saving = false
        if (res && res.success) {
          this.$message.success('保存并审核成功')
          this.visible = false
          this.loadData()
        } else {
          this.$message.error((res && res.message) || '审核失败')
          this.loadData()
        }
      }).catch(() => { this.saving = false; this.loadData() })
    },
    /** 保存并提交流程 */
    handleSaveAndFlow() {
      const task = this.saveBill()
      if (!task) return
      this.saving = true
      task.then((r) => this.submitFlowById(6, r.billNo)).then((res) => {
        this.saving = false
        if (res && res.code === 200) {
          this.visible = false
          this.loadData()
        }
      }).catch(() => { this.saving = false; this.loadData() })
    },
    handleDelete(r) {
      repairDelete(r.id).then((res) => {
        if (res && res.success) { this.$message.success('作废成功'); this.loadData() } else { this.$message.error((res && res.message) || '作废失败') }
      })
    },
    handleAudit(r) {
      repairAudit(r.id).then((res) => {
        if (res && res.success) { this.$message.success('审核成功'); this.loadData() } else { this.$message.error((res && res.message) || '审核失败') }
      })
    },
    handleUnaudit(r) {
      repairUnaudit(r.id).then((res) => {
        if (res && res.success) { this.$message.success('反审核成功'); this.loadData() } else { this.$message.error((res && res.message) || '反审核失败') }
      })
    },
    /** 提交审批（workflow bigType=6 维修单） */
    handleSubmitFlow(r) {
      this.$confirm({
        title: '提交审批', content: `确认提交维修单 ${r.billNo} 至审批流程？`,
        onOk: () => this.submitFlowById(6, r.billNo).then((res) => {
          if (res && res.code === 200) this.loadData()
        })
      })
    },
    exportExcel() {
      const list = this.tableData.map((r) => [
        r.billNo || '', (r.billTime || '').substring(0, 10), r.assetCode || '', r.assetName || '',
        r.repairType || '', r.amount == null ? '' : r.amount, r.repairContent || '',
        r.status === '1' ? '已审核' : '未审核'
      ])
      this.handleExportXlsPost('资产维修单', '资产维修单', '单据号,单据日期,资产编码,资产名称,维修类型,维修金额,维修内容,状态', '', list)
    }
  }
}
</script>
